<template>
  <div class="home-content">
      <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>Site Messages</div>
      <div class="third-pard">
        <div v-show="!nodata">
          <div class="list" v-for="(i,index) in list" v-bind:key="index">
            <ul @click="controlDisplay(index,i)">
              <div class="unread">
                <img src="@/assets/images/base/unread.png" v-if="i.is_read==1"/>
                <img src="@/assets/images/base/isread.png" v-else/>
                <div class="send_time">{{util.formatTime(i.send_time)}}</div>
              </div>
              <li class="b-title" v-show="isDetail==index">
                {{i.title}}
              </li>
              <textarea readonly v-show="isDetail==index" class="b-content" v-html="i.content"></textarea>
            </ul>
          </div>
        </div>
        <div class="nodata" v-show="nodata"><img src="@/assets/images/icon/data_icon_219962.png"/><span>No data available</span></div>
        <div class="show-more" v-if="list.length>=10" @click="showMore()">{{hasMore?"See more records, click here":"No more data"}}</div>
      </div>
      <van-loading
      v-show="showloding"
      size="50px"
      color="#1989fa"
      vertical/>
  </div>
</template>
<script>
/*global mui*/
  import Vue from "vue";
  import { Loading } from "vant";
  Vue.use(Loading);
  export default {
    data() {
      return {
        showloding: false,
        timeType:1,
        nodata:true,
        status:1,
        pageNo:1,
        pageSize:10,
        hasMore:true,
        list:[],
        category:0,
        one:{},
        isDetail:-1,
      };
    },
    methods: {
      showMore(){
        if(this.hasMore){
          this.pageNo += 1;
          this.getMessage();
        }
      },
      controlDisplay(index,one){
        this.isDetail = index;
        if(one.is_read==1){
          let params = {msgId: one.id};
          this.util.setDnValueToken(params);
          this.axios.post(this.api.api_readSiteMessage, this.util.encodeSearchParams(params)).then(res => {
            if (res.data.code == 0) {
              one.is_read = 2;
            } else {
              mui.toast(res.data.message);
            }
          }).catch(() => {
              this.showloding = false;
              mui.toast("Failed to read message");
            });
        }
      },
      getSiteMessage() {
        this.showloding = true;
        let params = {};
        this.util.setDnValueUser(params);
        params.pageNo = this.pageNo;
        params.pageSize = this.pageSize;
        this.axios.get(this.api.api_getSiteMessage, {params: params}) .then(res => {
            if(this.pageNo==1) this.nodata = true;
            this.showloding = false;
            if (res.data.code == 0) {
              let list = res.data.data;
              if(list.length>0) {
                this.nodata = false;
                this.list = this.list.concat(list);
              }else{
                this.hasMore = false;
              }
            } else {
              this.util.checkToken(res.data.message);
            }
          });
      },
    },
    activated(){
      if(this.util.isLogin()){
        this.userInfo = this.util.user;
        this.list = [];
        this.getSiteMessage();
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .home-content{
    font-size: 0.32rem;
    background: rgb(235, 235, 235);
    color:rgb(103, 103, 103);
    width: 100%;
    height: 100%;
    .mine-header{
      color:black;
      font-weight: bold;
      height: 1.2rem;
      display: grid;
      grid-template-columns: 30% 1fr 30%;
      align-items: center;
      text-align: center;
      .back{
        cursor: pointer;
        img{
          display: block;
          margin-left: 5%;
          width: 0.5rem;
          transform: rotate(180deg);
        }
      }
    }
    .dshow{
      display:"display";
    }
    .dshide{
      display: "none";
    }
    .third-pard{
      height: 100%;
      padding-bottom: 160px;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      .nodata{
        margin-top: 50px;
        height: 50px;
        display: grid;
        justify-content: center;
        font-size: 0.34rem;
        img{
          display: block;
          width: 35px;
          margin: auto;
        }
      }
      .show-more{
        height: 50px;
        display: flex;
        cursor: pointer;
        justify-content: center;
        align-items: center;
      }
      .list{
        width: 96%;
        display: grid;
        align-items: center;
        margin: 10px auto;
        margin-top: 0;
        border-radius: 10px/10px;
        background-color: white;
        padding: 5px 10px;
        .unread{
          display: flex;
          align-items: center;
          width: 100%;
          img{
            width: 30px;
            height: auto;
            display: block;
          }
          .send_time{
            width: 160px;
            margin-left: auto;
            text-align: right;
          }
        }
        .b-title{
          text-align: center;
          font-weight: bold;
          color:black;
        }
        .b-time{
          padding: 1px 0;
          text-align: center;
        }
        .b-content{
          min-height: 500px;
          font-size: 0.32rem;
          border: none;
        }
      }
    }
  }
  </style>  